// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var nextAvailableThatDayIsSymbol = {
    reflectSymbol: function () {
        return "nextAvailableThatDay";
    }
};
var OrderingPossibleIsSymbol = {
    reflectSymbol: function () {
        return "OrderingPossible";
    }
};
var reasonIsSymbol = {
    reflectSymbol: function () {
        return "reason";
    }
};
var OrderingImpossibleIsSymbol = {
    reflectSymbol: function () {
        return "OrderingImpossible";
    }
};
var decodeSingleConstructorAr = /* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr();
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil);
var OrderingPossible = /* #__PURE__ */ (function () {
    function OrderingPossible(value0) {
        this.value0 = value0;
    };
    OrderingPossible.create = function (value0) {
        return new OrderingPossible(value0);
    };
    return OrderingPossible;
})();
var OrderingImpossible = /* #__PURE__ */ (function () {
    function OrderingImpossible(value0) {
        this.value0 = value0;
    };
    OrderingImpossible.create = function (value0) {
        return new OrderingImpossible(value0);
    };
    return OrderingImpossible;
})();
var toFillFormTypeOrderingAva = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqOrderingAvailability = {
    eq: function (x) {
        return function (y) {
            if (x instanceof OrderingPossible && y instanceof OrderingPossible) {
                return eq(x.value0.nextAvailableThatDay)(y.value0.nextAvailableThatDay);
            };
            if (x instanceof OrderingImpossible && y instanceof OrderingImpossible) {
                return x.value0.reason === y.value0.reason;
            };
            return false;
        };
    }
};
var genericOrderingAvailability = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new OrderingPossible(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new OrderingImpossible(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Restaurants.Types.OrderingAvailability (line 15, column 1 - line 15, column 95): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof OrderingPossible) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof OrderingImpossible) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Restaurants.Types.OrderingAvailability (line 15, column 1 - line 15, column 95): " + [ x.constructor.name ]);
    }
};
var showOrderingAvailability = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderingAvailability)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(nextAvailableThatDayIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))))(OrderingPossibleIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(reasonIsSymbol)(Data_Show.showString))))(OrderingImpossibleIsSymbol)))
};
var unscrambleDecodeOrderingAvailability = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderingAvailability)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(OrderingPossibleIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(nextAvailableThatDayIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(OrderingImpossibleIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(reasonIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeOrderingAvailability = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericOrderingAvailability)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(OrderingPossibleIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(nextAvailableThatDayIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(OrderingImpossibleIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(reasonIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))
};
var decodeOrderingAvailability = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericOrderingAvailability)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(OrderingPossibleIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(nextAvailableThatDayIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(OrderingImpossibleIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons(reasonIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument)))
};
export {
    OrderingPossible,
    OrderingImpossible,
    genericOrderingAvailability,
    eqOrderingAvailability,
    showOrderingAvailability,
    encodeOrderingAvailability,
    decodeOrderingAvailability,
    unscrambleDecodeOrderingAvailability,
    toFillFormTypeOrderingAva
};
